import React, { useState } from "react";
import axios from "axios";
import { useHistory, Link } from "react-router-dom";
import Snackbar from "../LoadingError/snackbar";
import ButtonLoader from "../LoadingError/buttonLoader";
import buildLink from "../../urls";
import Cookies from "js-cookie";
import { handleError } from "../../services/functions";
import Loading from "../LoadingError/Loading";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect } from "react";

const AddCustomerMain = () => {
  const [customerData, setProductData] = useState();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [telephone, setTelephone] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [email, setEmail] = useState("");
  const [deliveryFees, setDeliveryFees] = useState();
  const [deliveryTime, setDeliveryTime] = useState("00:00");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [snackbarColor, setSnackbarColor] = useState({});
  const [validationErrors, setValidationErrors] = useState();
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const customerId = queryParams?.get("customer_id");

  const addCustomer = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const body = {
      firstname: firstName,
      lastname: " ",
      password: password,
      confirm_password: confirmPassword,
      telephone:
        telephone?.startsWith("+961")
        ? `+961${telephone.slice(4)}`
        : `+961${telephone}`,
      company_name: companyName,
      email: email,
      delivery_fees: deliveryFees ? parseFloat(deliveryFees) : 0,
      delivery_time: deliveryTime || "00:00",
    };

    if (deliveryFees == 0) {
      setSnackbarMessage(`Delivery fees should be greater than 0`);
      setSnackbarColor({ backgroundColor: "#FF0000" });
      setShowSnackbar(true);
      setLoadingCreate(false);
      setSubmitting(false);
      setTimeout(() => {
        setShowSnackbar(false);
      }, 1200);
    }

    if (
      firstName !== "" &&
      (!customerId ? password !== "" : true) &&
      (!customerId ? confirmPassword !== "" : true) &&
      telephone !== "" &&
      companyName !== "" &&
      email !== "" &&
      deliveryFees > 0
    ) {
      try {
        setLoadingCreate(true);

        const apiUrl = customerData
          ? buildLink("customer") + `?customer_id=${customerData.customer_id}`
          : buildLink("customer");

        const response = await axios({
          method: customerData ? "put" : "post",
          url: apiUrl,
          headers: {
            source: "2",
            Authorization: "Bearer " + Cookies.get("token"),
            "Content-Type": "application/json",
          },
          data: body,
        });

        if (response.status === 201 || response.status === 200) {
          const action = customerData ? "updated" : "added";
          setSnackbarMessage(`Customer ${action} successfully!`);
          setSnackbarColor({ backgroundColor: "#4CAF50" });
          setShowSnackbar(true);
          setLoadingCreate(false);
          setSubmitting(false);
          setTimeout(() => {
            setShowSnackbar(false);
            history.goBack();
          }, 1200);
        } else {
          console.error("Error:", response);
          handleError(
            response,
            setSnackbarMessage,
            setSnackbarColor,
            setShowSnackbar,
            setLoading,
            setLoadingCreate
          );
        }
      } catch (error) {
        handleError(
          error,
          setSnackbarMessage,
          setSnackbarColor,
          setShowSnackbar,
          setLoading,
          setLoadingCreate
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        buildLink("customer") + `?customer_id=${customerId}`,
        {
          headers: {
            source: "2",
            Authorization: "Bearer " + Cookies.get("token"),
          },
        }
      );

      if (response.status === 200) {
        setProductData(response.data.data);
      } else {
        console.error("Error:", response);
        handleError(
          response,
          setSnackbarMessage,
          setSnackbarColor,
          setShowSnackbar,
          setLoading
        );
      }
    } catch (error) {
      handleError(
        error,
        setSnackbarMessage,
        setSnackbarColor,
        setShowSnackbar,
        setLoading
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (customerId) {
      fetchData();
    }
  }, [customerId]);

  useEffect(() => {
    if (!customerId) {
      // fetchData();
      resetFormFields();
    }
  }, [customerId]);

  useEffect(() => {
    // console.log(customerData);
    if (customerData) {
      setCompanyName(customerData.company_name);
      setFirstName(customerData.firstname);
      setLastName(customerData.lastname);
      setEmail(customerData.email);
      setTelephone(`${customerData.telephone}`);
      setDeliveryFees(
        customerData.delivery_fees === "" ? 0 : customerData?.delivery_fees
      );
      setDeliveryTime(customerData?.delivery_time || "00:00");
    }
  }, [customerData]);

  const resetFormFields = () => {
    setCompanyName("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setTelephone("");
    setDeliveryFees("");
    setSubmitting(false);
    setDeliveryTime("00:00");
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (e.target.value !== confirmPassword) {
      setValidationErrors("Password does not match.");
    } else {
      setValidationErrors("");
    }
    if (confirmPassword === "") {
      setValidationErrors("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    if (password !== e.target.value) {
      setValidationErrors("Password does not match.");
    } else {
      setValidationErrors("");
    }
  };

  return (
    <>
      <section className="content-main">
        <form onSubmit={addCustomer}>
          {/* Sticky header bar */}
          <div
            className="d-flex align-items-center justify-content-between mb-3 position-sticky top-0 bg-white py-2"
            style={{ zIndex: 10 }}
          >
            <button
              type="button"
              onClick={() => history.goBack()}
              className="btn btn-danger text-white"
            >
              Back
            </button>

            <h2 className="content-title m-0">
              {customerData ? "Edit" : "Add"} Customer
            </h2>

            <button
              type="submit"
              className="btn btnhoverdark text-white"
              disabled={loadingCreate}
            >
              {loadingCreate ? (
                <ButtonLoader />
              ) : (
                <>{customerId ? "Update" : "Add"}</>
              )}
            </button>
          </div>

          {loading && customerId ? (
            <Loading />
          ) : (
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="row g-4">
                  {/* Company Name */}
                  <div className="col-12 col-md-6">
                    <label
                      htmlFor="company_name"
                      className="form-label fw-semibold"
                    >
                      Company Name
                    </label>
                    {submitting && (!companyName || companyName === "") && (
                      <span className="required-content"></span>
                    )}
                    <input
                      type="text"
                      id="company_name"
                      className={
                        submitting && (!companyName || companyName === "")
                          ? "required-field form-control"
                          : "form-control"
                      }
                      placeholder="Company Name"
                      required
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                    />
                  </div>

                  {/* Contact Name */}
                  <div className="col-12 col-md-6">
                    <label
                      htmlFor="first_name"
                      className="form-label fw-semibold"
                    >
                      Contact Name
                    </label>
                    {submitting && (!firstName || firstName === "") && (
                      <span className="required-content"></span>
                    )}
                    <input
                      type="text"
                      id="first_name"
                      className={
                        submitting && (!firstName || firstName === "")
                          ? "required-field form-control"
                          : "form-control"
                      }
                      placeholder="John Doe"
                      maxLength="50"
                      required
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>

                  {/* Passwords (create only) */}
                  {!customerData && (
                    <>
                      <div className="col-12 col-md-6">
                        <label
                          htmlFor="password"
                          className="form-label fw-semibold"
                        >
                          Password
                        </label>
                        {submitting && (!password || password === "") && (
                          <span className="required-content"></span>
                        )}
                        <input
                          type="password"
                          id="password"
                          className={
                            submitting && (!password || password === "")
                              ? "required-field form-control"
                              : "form-control"
                          }
                          placeholder="********"
                          required
                          value={password}
                          onChange={handlePasswordChange}
                        />
                      </div>

                      <div className="col-12 col-md-6">
                        <label
                          htmlFor="confirm_password"
                          className="form-label fw-semibold"
                        >
                          Confirm Password
                        </label>
                        {submitting &&
                          (!confirmPassword || confirmPassword === "") && (
                            <span className="required-content"></span>
                          )}
                        <input
                          type="password"
                          id="confirm_password"
                          className={
                            submitting &&
                            (!confirmPassword ||
                              confirmPassword === "" ||
                              validationErrors)
                              ? "required-field form-control"
                              : "form-control"
                          }
                          placeholder="********"
                          required
                          value={confirmPassword}
                          onChange={handleConfirmPasswordChange}
                        />
                        {validationErrors && (
                          <div className="text-danger mt-1">
                            {validationErrors}
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {/* Phone */}
                  <div className="col-12 col-md-6">
                    <label
                      htmlFor="telephone"
                      className="form-label fw-semibold"
                    >
                      Phone Number
                    </label>
                    {submitting && (!telephone || telephone === "") && (
                      <span className="required-content"></span>
                    )}
                    <div className="input-group">
                      {/* <span className="input-group-text">+961</span> */}
                      <input
                        type="text"
                        id="telephone"
                        className={
                          submitting && (!telephone || telephone === "")
                            ? "required-field form-control"
                            : "form-control"
                        }
                        placeholder="8 digits only xxxxxxxx"
                        pattern="[0-9]{8}"
                        title="Please enter 8 digits"
                        required
                        value={telephone}
                        onChange={(e) => {
                          const input = e.target.value;
                          if (/^\d{0,8}$/.test(input)) setTelephone(input);
                        }}
                        disabled={!!customerData}
                      />
                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-12 col-md-6">
                    <label htmlFor="email" className="form-label fw-semibold">
                      Email
                    </label>
                    {submitting && (!email || email === "") && (
                      <span className="required-content"></span>
                    )}
                    <input
                      type="email"
                      id="email"
                      className={
                        submitting && (!email || email === "")
                          ? "required-field form-control"
                          : "form-control"
                      }
                      placeholder="johndoe@gmail.com"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={!!customerData}
                    />
                  </div>

                  {/* Delivery Fees */}
                  <div className="col-12 col-md-6">
                    <label
                      htmlFor="delivery_fees"
                      className="form-label fw-semibold"
                    >
                      Delivery Fees ($)
                    </label>
                    {submitting &&
                      (!deliveryFees || Number(deliveryFees) <= 0) && (
                        <span className="required-content"></span>
                      )}
                    <input
                      id="delivery_fees"
                      type="number"
                      className={
                        submitting &&
                        (!deliveryFees || Number(deliveryFees) <= 0)
                          ? "required-field form-control"
                          : "form-control"
                      }
                      placeholder="xxx"
                      required
                      value={deliveryFees}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (/^\d{0,3}$/.test(v)) setDeliveryFees(v);
                      }}
                      onKeyDown={(e) => {
                        if ([".", ",", "-", "e", "+"].includes(e.key))
                          e.preventDefault();
                      }}
                      onWheel={(e) => e.currentTarget.blur()}
                      min={1}
                      max={999}
                      step={1}
                    />
                  </div>

                  {/* Delivery Time (24h dropdown) */}
                  <div className="col-12 col-md-6">
                    <label
                      htmlFor="delivery_time"
                      className="form-label fw-semibold"
                    >
                      Delivery Time (24h)
                    </label>
                    {submitting && (!deliveryTime || deliveryTime === "") && (
                      <span className="required-content"></span>
                    )}
                    <select
                      id="delivery_time"
                      className={
                        submitting && (!deliveryTime || deliveryTime === "")
                          ? "required-field form-control"
                          : "form-control"
                      }
                      value={deliveryTime}
                      onChange={(e) => setDeliveryTime(e.target.value)}
                      required
                    >
                      {Array.from({ length: 48 }, (_, i) => {
                        const hours = String(Math.floor(i / 2)).padStart(
                          2,
                          "0"
                        );
                        const minutes = i % 2 === 0 ? "00" : "30";
                        const t = `${hours}:${minutes}`;
                        return (
                          <option key={t} value={t}>
                            {t}
                          </option>
                        );
                      })}
                    </select>
                    <small className="text-muted">
                      Select delivery time in 24h format
                    </small>
                  </div>
                </div>
              </div>
            </div>
          )}
          {showSnackbar && (
            <Snackbar message={snackbarMessage} style={snackbarColor} />
          )}
        </form>
      </section>
    </>
  );
};

export default AddCustomerMain;
